import { Coordinates } from "./Coordinates";
export class ShortCoordinates extends Coordinates {
  constructor(lat, lng) {
    super(lat, lng);
  }
}